import script from "./BaseInput2.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseInput2.vue?vue&type=script&setup=true&lang=js"

import "./BaseInput2.vue?vue&type=style&index=0&id=c964d36a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c964d36a"]])

export default __exports__